/* global API_KEYS, window */

import get from 'lodash/get';

export const getEnvConstants = () => {
  if (window.ENV_CONSTANTS_LOADED !== true) {
    const apiKeys = typeof API_KEYS === 'undefined' ? {} : API_KEYS;
    const rootElement = document.querySelector('html');
    const env = get(rootElement, 'dataset.railsEnv', 'test');

    window.REDUX_LOGGING = env === 'production' || env === 'test' ? false : true;
    window.RUNTIME_ENV = env;
    window.AMPLITUDE_API_KEY = get(apiKeys, [env, 'amplitude'], null);
    window.GOOGLE_MAPS_API_KEY = get(apiKeys, [env, 'googleMaps'], null);
    window.ROLLBAR_TOKEN = get(apiKeys, [env, 'rollbar'], null);
    window.STRIPE_PUBLIC_KEY = get(apiKeys, [env, 'stripe'], 'stripe');
    window.ENV_CONSTANTS_LOADED = true;
  }

  return {
    REDUX_LOGGING: window.REDUX_LOGGING,
    RUNTIME_ENV: window.RUNTIME_ENV,
    AMPLITUDE_API_KEY: window.AMPLITUDE_API_KEY,
    GOOGLE_MAPS_API_KEY: window.GOOGLE_MAPS_API_KEY,
    ROLLBAR_TOKEN: window.ROLLBAR_TOKEN,
    STRIPE_PUBLIC_KEY: window.STRIPE_PUBLIC_KEY,
  };
};
